const findQuestion = (qID, answers) => {
  return new Promise((res, rej) => {
    res(answers.find((ans) => ans.qID === qID).answer);
  });
};

export default findQuestion;
